import { makeAutoObservable, runInAction, reaction } from 'mobx';
import axios from 'axios';
import urls from './Urls';

class SearchStore {
    text = '';
    dictionaryType = 'dictionary_eng_to_heb';
    operator = 'text';

    fuzzy = {
        maxEdits: 1,
        prefixLength: 1,
        maxExpansions: 50,
    };

    k = 20;
    highlightPath = ['originalWithoutPunctuation'];

    additionalInfoFilters = {
        images: {},
        sentences: {},
    };

    limit = 20;
    skip = 0;
    totalCount = false;

    selectFields = ['originalWithoutPunctuation', 'original', 'trns', 'pos', 'band', 'score', 'highlights'];

    compoundDefinition = null;

    results = [];
    loading = false;

    filters = {
        band: {
            values: [],
            type: 'or',
        },
    };

    constructor() {
        makeAutoObservable(this);

        reaction(
            () => [
                this.text,
                this.dictionaryType,
                this.operator,
                this.k,
                JSON.stringify(this.fuzzy),
                JSON.stringify(this.additionalInfoFilters),
                JSON.stringify(this.highlightPath),
                JSON.stringify(this.compoundDefinition),
                JSON.stringify(this.filters),
                this.limit,
            ],
            () => {
                if (this.text.trim()) {
                    this.performSearch();
                } else {
                    runInAction(() => {
                        this.results = [];
                    });
                }
            },
            { delay: 300 }
        );
    }

    setText = (val) => this.text = val;
    setOperator = (val) => this.operator = val;
    setDictionaryType = (val) => this.dictionaryType = val;
    setFuzzy = (key, val) => this.fuzzy[key] = val;
    setHighlightPath = (val) => this.highlightPath = val;

    setLimit = (val) => {
        this.limit = val;
        this.k = val;
    };

    setCompoundDefinition = (definition) => this.compoundDefinition = definition;
    setBandFilter = (values) => this.filters.band.values = values;

    setAdditionalInfoCondition = (field, operator, value) => {
        if (!this.additionalInfoFilters[field]) this.additionalInfoFilters[field] = {};
        this.additionalInfoFilters[field][operator] = value;
    };

    get builtQuery() {
        const query = {
            dictionaryType: this.dictionaryType,
            searchOperator: {
                operator: this.operator,
            },
            limit: this.limit,
            skip: this.skip,
            totalCount: false,
            selectFields: this.selectFields,
        };

        if (this.operator === 'knnBeta') {
            query.searchOperator.text = this.text;
            query.searchOperator.definition = {
                path: 'embedding',
                k: this.k,
            };
        } else if (this.operator === 'compound') {
            query.searchOperator.definition = this.compoundDefinition || {};
            if (this.highlightPath) {
                query.searchOperator.highlightPath = this.highlightPath;
            }
        } else {
            query.searchOperator.definition = {
                query: this.text,
                path: 'originalWithoutPunctuation',
                fuzzy: this.fuzzy,
            };
            if (this.highlightPath) {
                query.searchOperator.highlightPath = this.highlightPath;
            }
        }

        if (Object.keys(this.additionalInfoFilters).some(f => Object.keys(this.additionalInfoFilters[f]).length > 0)) {
            query.additionalInfoFilters = this.additionalInfoFilters;
        }

        if (this.filters.band.values.length > 0) {
            query.filters = {
                band: {
                    values: this.filters.band.values,
                    type: this.filters.band.type,
                }
            };
        }

        return query;
    }

    performSearch = async () => {
        this.loading = true;
        try {
            const res = await axios.post(
                // urls.search.smartSearch,
                'https://test.lexillon.co.il/api/dictionary/v2/smart-search',
                this.builtQuery,
                { withCredentials: true }
            );
            runInAction(() => {
                this.results = res.data.results || [];
            });
        } catch (err) {
            console.error('❌ Search error:', err);
            runInAction(() => {
                this.results = [];
            });
        } finally {
            runInAction(() => {
                this.loading = false;
            });
        }
    };
}

const searchStore = new SearchStore();
export default searchStore;
